var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more_button"},[_c('div',[_c('router-link',{attrs:{"to":_vm.button_href}},[_vm._v("  \n        "+_vm._s(_vm.button_text)+"\n      ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }